import type {
  ListWebSocketEvents,
  ThinkingStepWebSocketEvents,
} from "@advanced-sales-technologies/octrace-client/websocket-types";
import { type Socket } from "socket.io-client";

export enum ConnectionStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  RECONNECTING = "reconnecting",
  ERROR = "error",
}

export type ConnectionState = {
  status: ConnectionStatus;
  error?: string;
  lastConnected?: Date;
  reconnectAttempts: number;
};

export type SystemEvents = {
  connect: () => void;
  disconnect: (reason: string) => void;
  connect_error: (error: Error) => void;
  reconnect: (attemptNumber: number) => void;
  reconnect_attempt: (attemptNumber: number) => void;
  reconnect_error: (error: Error) => void;
  reconnect_failed: () => void;
};

export type AppEvents = ThinkingStepWebSocketEvents & ListWebSocketEvents;

export type SocketEvents = SystemEvents & AppEvents;

export type TypedSocket = Socket<SocketEvents, SocketEvents>;

export type WebSocketContextType = {
  connectionState: ConnectionState;
  subscribeToNamespace: (namespace: string, query?: Record<string, string>) => Promise<TypedSocket>;
  unsubscribeFromNamespace: (namespace: string, query?: Record<string, string>) => void;
  isConnected: boolean;
};
